export const sharedColors = {
    black: '#000000',
    white: '#ffffff',
    characterSecondary: '#87878a',
}
